const second = 1000
const minute = 60 * second
const hour = 60 * minute
const day = 24 * hour
const week = 7 * day

const STALE_TIMES = {
    SECOND: second,
    MINUTE: minute,
    HOUR: hour,
    DAY: day,
    WEEK: week,
}

export default STALE_TIMES